import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
// component, hooks
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import LoginTop from "../common/LoginTop";
import LoginBottom from "../common/LoginBottom";
import EmailSignUp from "./EmailSignUp";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import { ROUTE_PATH } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
//
import FirebaseAuthLogin from "../common/FirebaseAuthLogin";

// style

const StyledBoxDividerSplit = styled(
  Box,
  {}
)(({ theme }) => ({
  width: "126px",
  height: "0.5px",
  backgroundColor: "#505050",
}));

const StyledLinkDark = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#121212",
  cursor: "pointer",
}));

const StyledLinkBlue = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#3bbff0",
  cursor: "pointer",
}));

const CustomSignUpUI = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const handleGoLogIn = () => {
    navigate(handleLocaleRoute(ROUTE_PATH.LogIn));
  };

  return (
    <Box
      width="400px"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box width="300px" mb={6}>
        <LoginTop />

        {/* firebase login */}
        <Box>
          <FirebaseAuthLogin />
        </Box>

        <Box display="flex" mb={4} alignItems="center" justifyContent="center">
          <StyledBoxDividerSplit />
          <Box mx={2}>
            <Typography>
              {intl.formatMessage({
                id: "login.singin.or",
                defaultMessage: "或",
              })}
            </Typography>
          </Box>
          <StyledBoxDividerSplit />
        </Box>

        {/* email login */}
        <EmailSignUp />

        <Box>
          <Typography textAlign="center">
            <span>
              {intl.formatMessage({
                id: "login.already.has.account.question",
                defaultMessage: "已經有帳號了？",
              })}
            </span>
            <StyledLinkBlue onClick={handleGoLogIn}>
              {intl.formatMessage({
                id: "login.already.has.account.login",
                defaultMessage: "登入",
              })}
            </StyledLinkBlue>
          </Typography>
        </Box>
      </Box>

      <Box width="400px">
        <LoginBottom />
      </Box>
    </Box>
  );
};

CustomSignUpUI.propTypes = {};

CustomSignUpUI.defaultProps = {};

export default CustomSignUpUI;
